import { Typography } from "@mui/material";
import { PictureUploadSubtypeResponse, PictureUploadSubtypeDataModel } from "../../../../../../types/actionModule/subtypes/pictureUploadModels";
import { useTranslation } from "react-i18next";

interface Props {
    subtype: PictureUploadSubtypeResponse;
    subtypeData: PictureUploadSubtypeDataModel;
}

export default function PictureUploadSubtypeSummary(props: Props) {
    const { t } = useTranslation();

    return <Typography>{t("incentivationPage.pictureUpload.numberUploadedImages", {count: 1})}</Typography>
}
